import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18463b8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__buttons" }

import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
} from '@ionic/vue';

interface Props {
  hasCombinations?: boolean;
  hasPackages?: boolean;
  hasPlacements?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicItemDetailsHeader',
  props: {
    hasCombinations: { type: Boolean },
    hasPackages: { type: Boolean },
    hasPlacements: { type: Boolean }
  },
  emits: ["openCombinations", "openPackages", "openPlacements"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'openCombinations'): void
  (e: 'openPackages'): void
  (e: 'openPlacements'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  hasCombinations?: boolean;
  hasPackages?: boolean;
  hasPlacements?: boolean;
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), { class: "product__wrapper" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonTitle), null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      (props.hasPackages || props.hasCombinations || props.hasPlacements)
        ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (props.hasCombinations)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openCombinations')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Combinations ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (props.hasPackages)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('openPackages')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Packages ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (props.hasPlacements)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 2,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('openPlacements')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Placements ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})